module.exports = __webpack_public_path__ + "img/beep-icon.5e541511.jpg";